import {
  SET_GENERATED_LINEUP_COUNT,
  SET_LINEUP_SAVED_FLAG,
  SET_SAVED_LINEUP_COUNT,
} from "./Lineup";

export const setLineupSavedFlag = (value) => {
  console.log("Lineup Saved Flag", value);
  return {
    type: SET_LINEUP_SAVED_FLAG,
    lineup_saved_flag: value,
  };
};
export const setGeneratedLineupCount = (value) => {
  console.log("Generated Lineup Count", value);
  return {
    type: SET_GENERATED_LINEUP_COUNT,
    generated_lineup_count: value,
  };
};
export const setSavedLineupCount = (value) => {
  console.log("Lineup Saved Count", value);
  return {
    type: SET_SAVED_LINEUP_COUNT,
    saved_lineup_count: value,
  };
};
